import React from 'react';
import { Rules } from 'containers/rules';
import { usePageViewEvent } from 'common/hooks';

export const RulesPage = () => {
	usePageViewEvent();

	return <Rules />;
};
